<template>
  <div>
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <div style="width:98%;margin:0 auto;padding:0;padding: 0">
        <Nav ref="navRef"></Nav>
      </div>
      <!--select-->
      <div class="select-block" >
        <el-form :inline="true" class="demo-form-inline;" style="display: inline-block;margin-bottom: 10px;">
          <provCity :provCityId="provCityId" v-if="this.$store.state.Code === '11'"></provCity>
          <el-form-item>
            <el-select  placeholder="请选择品目" v-model="catThreeId"  @click.native="getlistThreeCategory()" style="width: 160px" clearable>
              <el-option
                v-for="(item,index) in listThreeCategory"
                :label="item.dictName"
                :value="item.dictKey"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-select  placeholder="请选择跨区" v-model="crossRegion" style="width: 160px" clearable>
              <el-option label="跨省作业" :value="1"></el-option>
              <el-option label="跨市作业" :value="2"></el-option>
              <el-option label="跨区县作业" :value="3"></el-option>
            </el-select>
          </el-form-item> -->
          <!--时间-->
          <!-- <el-form-item label="日期">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="valueChange"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item> -->
          <el-form-item label="">
            <el-input v-model.trim="njFactoryCode" placeholder="请输入出厂编号" style="width: 160px" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model.trim="imei" placeholder="请输入监控编号" style="width: 160px" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <!--number-->
      </div>
      <!--table-->
      <el-main style="padding:0;">
      	<el-table :data="tableData">
					<el-table-column prop="id" label="序号" width="80" type="index">
						<template slot-scope="scope">
							<span>{{ (currentPage-1)*checkcurrentPage+parseInt(scope.$index)+1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="countyName" label="区" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="ownerName" label="机主" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="catThreeName" label="机具品目" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="factoryCode" label="出厂编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
						<el-table-column prop="buyTime" label="购机时间">
					</el-table-column>
					<el-table-column prop="lastArea" label="跨入地区" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="num" label="年度跨区天数" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
						<el-table-column prop="sumArea" label="年度跨区作业面积（亩）">
					</el-table-column>
						<el-table-column prop="imei" label="监控编号">
					</el-table-column>
					<el-table-column width="80" prop="address" label="操作">
						<template slot-scope="scope">
							<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
        <div v-if="nodata" class="zanwu">暂无数据</div>
      </el-main>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="checkcurrentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          v-if="tableData&&tableData[0]"
        >
        </el-pagination>
      </div>
      <div v-if="isloading" class="">
        <div class="el-loading-spinner"><i class="el-icon-loading"></i><p class="el-loading-text">加载中</p></div>
      </div>
    </el-container>
  </div>
</template>

<script>
  import Api from '../../Serves/net-api.js'
  import Http from '../../Serves/net-http.js'
  import provCity from "../Index/common/provCity";
  import Nav from "../../components/Subsidies/nav";
  import {mapState} from "vuex";
  export default {
    name: "SpanningAreaSubsidy",
    components: {provCity, Nav},
    data() {
      return {
        nodata:false,
        loading:false,//表格加载状态
        isloading:true,
        provCityId:{
          cityCode: '',
          provCode: '',
          countyCode:''
        },//省市区组件id
        total:1,
        currentPage:1,
        checkcurrentPage:12,
        pageSize: 12,
        listThreeCategory:[],
        catThreeId:'',
        crossRegion: '',
        njFactoryCode:'',
        imei:'',
        token:'',
        //日历
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: '',
        value2: '',
        value: [],
        options: [{ }],
        tableData: []
      }
    },
    computed:{
      ...mapState({
        result:state=>state.result
      })
    },
    activated() {
      this.$refs.navRef.activeName='跨区机具监管'
    },
    mounted(){
      sessionStorage.removeItem('manageParams1')
    	this.navId = sessionStorage.getItem('navClickVal');
      if (this.$store.state.SpanningAreaData.length !== 0) {
        var data = this.$store.state.SpanningAreaData
        this.provCityId.provCode = data.provCode
        this.provCityId.cityCode = data.cityCode
        this.provCityId.countyCode = data.countyCode
        this.imei = data.imei
        this.currentPage = data.currentPage
        this.pageSize = data.pageSize
        this.njFactoryCode = data.njFactoryCode
        this.catThreeId = data.catThreeId
        this.search()
        this.getlistThreeCategory()
      } else {
        this.getlistThreeCategory()
        this.getdata()
      }
    },
    methods: {
      // 查看
      handleClick(row) {
        var data = {
          provCode:this.provCityId.provCode,
          cityCode:this.provCityId.cityCode,
          countyCode:this.provCityId.countyCode,
          imei: this.imei,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          njFactoryCode: this.njFactoryCode,
          catThreeId: this.catThreeId
        }
        this.$store.commit('SpanningAreaData', data);
				this.$router.push({name:'SubsidyDetails',query:{imei: row.imei, qrNumber: row.qrNumber}})
      },
      // 获取列表数据
      getdata(){
        this.currentPage = 1
        this.search()
      },
      valueChange (val) {
        console.log(val)
        console.log(this.value1)
      },
      onSubmit() {
        this.nodata=false
        this.isloading=true
        this.currentPage = 1
        this.search()
      },
      //品目
      getlistThreeCategory(){
        // var url=Http.test+'/common/listThreeCategory'
        // var url=Http.test+'/dtIotNjData/getItemsByType'
        var url=Http.test+'/sysDict/getItemsByType'
        var parmse={
          // areaCode:this.result.areaCode,
          // level:this.result.areaLevel,
          // year: new Date().getFullYear()
        }
        Api.doPost(url,parmse,false,(res)=>{
          this.listThreeCategory = res.result
          // res.result.forEach(item => {
          //   if (item) {
          //     this.listThreeCategory.push(item)
          //   }
          // })
        },(doError)=>{
          console.log(doError)
        })
      },
      //改变pageSize
      handleSizeChange(val) {
        this.pageSize = val
        this.currentPage = 1
        this.search()
      },
      //分页请求
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage
        this.search()
      },
      //封装查询方法
      search(obj){
        var parmse={
          currentPage:this.currentPage,
          pageSize:this.pageSize,
          provCode:this.provCityId.provCode,
          cityCode:this.provCityId.cityCode,
          countyCode:this.provCityId.countyCode,
          catThreeId:this.catThreeId,
          // crossRegion: this.crossRegion,
          njFactoryCode:this.njFactoryCode,
          imei:this.imei,
          source: 1
        }
        this.loading = true
        this.isloading = true
        var url=Http.test+'/applicationSubsidy/selectNjTransRegionalPageInfo';
        Api.doPost(url,parmse,false,(res)=>{
          this.loading = false
          this.isloading = false
          this.tableData=res.result.dataSource
          this.total = res.result.totalRow
          if(this.tableData.length==0){
            this.nodata=true
          }else{
            this.nodata=false
          }
        },(doError)=>{
          console.log(doError)
        })
      }
    }
  }
</script>

<style scoped>
  .zanwu{
    text-align: center;
    font-size: 34px;
    color:#999;
    width:100%;
    height: 600px;
    line-height: 600px;
  }
  .el-table{
    width: 98% !important;
    margin: auto;
    color: #fff;
  }
  .block{
    width: 100%;
    margin-top: 1vh;
		display: -webkit-box;
		-webkit-box-align: center;
		-webkit-box-pack: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
  .select-block{
    display: inline-block;
    padding: 0 20px;
    /*height: 40px;*/
    line-height: 40px;
    margin-top: 10px;
    width: 97%;
  }
  header{
    height:0px !important;
  }
  form{
    display: inline-block;
  }
  .parameter{
    /*width: 100%;*/
    height: 85px;
    line-height: 85px;
    background: #101c4a;
    margin-bottom: 10px;
  }
  .parameter>div{
    margin-left: 30px;
    margin-top: 30px;
    color: #75c3ff;
  }
  .parameter>div div{
    display: inline-block;
  }
  .parameter div span{
    display: inline-block;
    line-height: 40px;
  }
  .parameter>div div span:nth-child(2){
    font-size: x-large;
    font-weight: bold;
    color: #fff;
    position: relative;
    top:5px;
  }
  .demonstration{
    padding-right: 20px;
  }
  .el-input__inner{
    border: 1px solid #273488 !important;
  }
  .el-date-editor .el-range-input{
    color: #606266 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableList/SpanningAreaSubsidy.vue